import PropTypes from 'prop-types';
import styles from './SoftwareCard.module.scss';
import React from 'react';
import Icon from '../Icon';
import Tag from '../Tag/Tag';
import Image from '../Image';

const SoftwareCard = ({ link, image, title, text, buttonText, tags }) => {
    if (!link) {
        return;
    }

    return (
        <a href={link?.href} className={styles['SoftwareCard']}>
            {tags && (
                <div className={styles['SoftwareCard__Tags']}>
                    {tags.map((tag, i) => (
                        <div key={i} className={styles['SoftwareCard__Tag']}>
                            <Tag {...tag} />
                        </div>
                    ))}
                </div>
            )}
            <div className={styles['SoftwareCard__Container']}>
                {image && (
                    <div className={styles['SoftwareCard__ImageWrapper']}>
                        <Image
                            {...image}
                            layout="fill"
                            objectFit="cover"
                            priority={true}
                        />
                    </div>
                )}

                <div className={styles['SoftwareCard__Content']}>
                    <h3 className={styles['SoftwareCard__Title']}>{title}</h3>
                    <div className={styles['SoftwareCard__Split']}>
                        <p className={styles['SoftwareCard__Text']}>{text}</p>
                        <div className={styles['SoftwareCard__Button']}>
                            <p className={styles['SoftwareCard__ButtonText']}>
                                {buttonText}
                            </p>
                            <Icon type="arrow" size="large" />
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
};

SoftwareCard.propTypes = {
    link: PropTypes.object,
    image: PropTypes.object,
    title: PropTypes.string,
    text: PropTypes.string,
    buttonText: PropTypes.string,
    tags: PropTypes.array,
};

export default SoftwareCard;
